import React, { Component} from 'react';
import { connect } from 'react-redux';
import './notification-lists.css';
import {
  Table,
  Segment,
  Modal,
  Header,
  Menu,
  Button,
  Message,
  Popup,
  Label,
  Icon,
} from 'semantic-ui-react';
import { NOTIFICATIONCONFIG } from '../notifications-config';
import {
  getNotifications,
  getCardHTML,
  editNotification,
  deleteNotification,
  setNotificationMessage,
} from '../../../actions/notification.actions';
import * as microsoftTeams from '@microsoft/teams-js';
import NotificationCreator from '../notification-creator/notification-creator';
import { GetNotificationRequiredInfo, NotificationModal, UserConfigModal } from '../../../modal/notification';
import history from '../../../helper/history';
import { DeleteRequestInfo } from '../../../modal/narrative-board';
import TeamsCard from '../../team-card/team-card';
import { CONFIG } from '../../../helper/config';
import { activeLoader,storeSessionId } from '../../../actions/view.actions';

interface IProps {
  notifications: NotificationModal[];
  card_html: any;
  notification_msg: string;
  is_license_expire: boolean;
  unregisterd_user_msg: string;
  is_unregisterd_user: boolean;
  active_loader: boolean;
  is_update_chart_view_state: boolean;
  sessionId:string;
  getNotifications: (arg0: GetNotificationRequiredInfo, auth_token: string, is_loader?: boolean) => void;
  getCardHTML: (arg0: number, arg1: string, arg2: any, auth_token: string,arg3:string) => void;
  editNotification: (arg0: number, arg1: any, auth_token: string,arg2:string) => void;
  deleteNotification: (arg0: number, arg1: DeleteRequestInfo, arg2: GetNotificationRequiredInfo, auth_token: string) => void;
  setNotificationMessage: (arg: string) => void;
  activeLoader: (active_loader: boolean) => void;
  storeSessionId:(arg: string) => void;
}

interface IState {
  unique_id: string;
  teams_context: any;
  open_modal: boolean;
  notification_mode: string;
  selected_notification?: NotificationModal;
  port_no: string;
  auth_token: string;
  open_notification_name_popup: number;
}

/**
 * NotificationList Component
 *
 * A React component that displays a list of notifications in a table format.
 * Provides functionality to create, edit, delete, enable/disable, and view
 * notification cards. Integrates with Microsoft Teams context and Redux
 * actions for data handling.
 */
export class NotificationList extends Component<IProps, IState> {
  auth_token: string = '';
  /**
   * Constructor
   * @param {IProps} props - The props for this component
   */
  constructor(props: IProps) {
    super(props);
    this.state = {
      unique_id: '',
      teams_context: {},
      open_modal: false,
      notification_mode: '',
      port_no: '',
      auth_token: '',
      open_notification_name_popup: -1,
    };
  }

  /**
   * getTeamsGroupId
   *
   * @param {any} teams_context - The context of the Microsoft Teams app.
   * @returns {string} - The group ID from the Teams context or an empty string.
   */
  getTeamsGroupId = (teams_context) => {
    if (teams_context.groupId) {
      return teams_context.groupId
    } else return ''
  }

  /**
   * componentDidMount()
   *
   * Called when the component has been mounted.
   *
   * Handles the logic for both Teams and WebApp.
   *
   * For Teams:
   * - Initializes the Microsoft Teams app.
   * - Gets the context (channel, team, user, etc.).
   * - Gets the auth token.
   * - Calls the getNotifications action with the context and token.
   * - Sets the component state.
   *
   * For WebApp:
   * - Listens for the message event.
   * - Parses the query parameters.
   * - Calls the getNotifications action with the context and token.
   * - Sets the component state.
   */
  componentDidMount() {

    const query_params = new URLSearchParams(history.location.search);
    const bot_id = query_params.get('bot_id');
    let teams_context: any = query_params.get('context')?.split(CONFIG.URLQUERYPARAMSEPERATOR)[0];
    teams_context = teams_context ? JSON.parse(teams_context) : {};
    console.log("componentDidMount teams_context :: ", teams_context)
    const port_no: any = query_params.get('port_no');
    let token = query_params.get('auth_token');
    microsoftTeams.app.initialize();
    microsoftTeams.app.notifySuccess();
    if (teams_context.userObjectId && token) {
      this.auth_token = token;
      let unique_id = teams_context.userObjectId + '____' + bot_id;
      let info: GetNotificationRequiredInfo = {
        user_bot_id: unique_id,
        user_id: teams_context.userObjectId,
        tenant_id: teams_context.tid,
        team_id: (teams_context.groupId) ? teams_context.groupId : '',
        destination_id: this.getDestinationID(teams_context),
        channelId: teams_context.channelId,
        group_id: teams_context.chatId ? teams_context.chatId : undefined
      }
      this.props.getNotifications(info, token);
      this.setState({ unique_id: unique_id, teams_context: teams_context, port_no: port_no });

    } else {
      microsoftTeams.app.initialize();
      microsoftTeams.app.notifySuccess();
      let comp_ref = this;

      microsoftTeams.app.getContext().then((context) => {
        console.log("context", context);
        teams_context.chatId = context.chat?.id;
        teams_context.meetingId = context.meeting?.id;
        teams_context.userObjectId = context.user?.id;
        teams_context.userPrincipalName = context.user?.userPrincipalName;
        teams_context.tid = context.user?.tenant?.id;
        teams_context.groupId = context.team?.groupId;
        teams_context.teams_channel_id = context.channel?.id;
        teams_context.destination_id = this.getDestinationID(teams_context);
        teams_context.channelId = 'msteams';
        console.log("teams_context :: ", teams_context);
        let unique_id = teams_context.userObjectId + '____' + bot_id;
        comp_ref.setState({ unique_id: unique_id, teams_context: teams_context, port_no: port_no });
        if (teams_context.userObjectId) {
          let info: GetNotificationRequiredInfo = {
            user_bot_id: unique_id,
            user_id: teams_context.userObjectId,
            tenant_id: teams_context.tid,
            team_id: this.getTeamsGroupId(teams_context),
            destination_id: teams_context.destination_id,
            channelId: teams_context.channelId,
            group_id: teams_context.chatId ? teams_context.chatId : undefined
          }
          microsoftTeams.authentication.getAuthToken().then( (token: string) => {
              if(!this.props.sessionId){
                let session_id = new Date().toString();
                  this.props.storeSessionId(session_id)
              }

              comp_ref.props.getNotifications(info, token, true);
              this.auth_token = token;
              this.setState({ auth_token: token });
              console.log("token :: ", token);
            })
            .catch((error) => {
              this.props.activeLoader(false);
              this.props.setNotificationMessage(error);
              console.error("reason :: ", error);
            })
          }
      }).catch((error) => {
        this.props.activeLoader(false);
      })
    }
  }

  /**
   * getDestinationID
   *
   * @param {any} teams_context - The context of the Microsoft Teams app.
   * @returns {string} - The destination ID based on the context (group, team, or personal).
   */
  getDestinationID = (teams_context: any) => {
    let destination_id = '';
    if (teams_context.meetingId) {
      //group scope
      destination_id = teams_context.chatId;
    }
    else if (teams_context.teams_channel_id) {
      //team scope
      destination_id = teams_context.groupId;
    } else {
      //personal scope
      destination_id = teams_context.userObjectId;
    }
    return destination_id;
  }

  /**
   * editNotification
   *
   * @param {NotificationModal} notification - The notification to be edited.
   * Sets the selected notification and opens the modal for editing.
   */
  editNotification = (notification: NotificationModal) => {
    this.setState({
      selected_notification: notification,
      open_modal: true,
      notification_mode: NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.EDIT,
    });
  };

  /**
   * updateNotificationStatus
   *
   * @param {NotificationModal} notification - The notification to be updated.
   * Toggles the active status of the notification and calls the editNotification action.
   */
  updateNotificationStatus = (notification: NotificationModal) => {
    let { teams_context } = this.state;
    let status = {
      active: !notification.active,
      tenant_id: teams_context.tid,
      team_id: (teams_context.groupId) ? teams_context.groupId : '',
      channelId: teams_context.channelId,
      user_id: teams_context.userObjectId,
      platform: notification.description ?? "teams"
    };
    this.props.editNotification(notification.id, status, this.auth_token,"notification-lists");
  };

  /**
   * openDeleteConfirmationDialog
   *
   * @param {NotificationModal} notification - The notification to be deleted.
   * Sets the selected notification and opens the modal for deletion confirmation.
   */
  openDeleteConfirmationDialog = (notification: NotificationModal) => {
    this.setState({
      selected_notification: notification,
      open_modal: true,
      notification_mode: NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.DELETE,
    });
  };

  /**
   * viewNotificationCard
   *
   * @param {NotificationModal} notification - The notification to be viewed.
   * Sets the selected notification and opens the modal for viewing the card.
   */
  viewNotificationCard = (notification: NotificationModal) => {
    this.setState({
      selected_notification: notification,
      open_modal: true,
      notification_mode: NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.VIEWCARD
    });
    let { port_no, teams_context } = this.state;
    this.props.getCardHTML(notification.id, port_no, teams_context, this.auth_token,notification.description);
  }

  /**
   * deleteNotification
   *
   * Deletes the selected notification.
   * Calls the deleteNotification action with the selected notification ID and required info.
   */
  deleteNotification = () => {
    const { selected_notification, unique_id, teams_context } = this.state;
    if (selected_notification) {
      let info: GetNotificationRequiredInfo = {
        user_bot_id: unique_id,
        user_id: teams_context.userObjectId,
        tenant_id: teams_context.tid,
        team_id: (teams_context.groupId) ? teams_context.groupId : '',
        destination_id: teams_context.destination_id,
        channelId: teams_context.channelId
      }
      let delete_info: DeleteRequestInfo = {
        user_id: teams_context.userObjectId,
        team_id: (teams_context.groupId) ? teams_context.groupId : '',
        tenant_id: teams_context.tid,
        channelId: teams_context.channelId
      }
      this.props.deleteNotification(selected_notification.id, delete_info, info, this.auth_token);
    }
    this.modelClose();
  }

  /**
   * updateNotification
   *
   * @param {any} info - The updated notification information.
   * Calls the editNotification action with the selected notification ID and updated info.
   */
  updateNotification = (info: any) => {
    const { selected_notification, teams_context } = this.state;
    let user_config_keys: UserConfigModal = {
      tenant_id: teams_context.tid,
      team_id: (teams_context.groupId) ? teams_context.groupId : '',
      channelId: teams_context.channelId,
      user_id: teams_context.userObjectId,
      platform:selected_notification?.description ?? "teams"
    };
    info = { ...info, ...user_config_keys };
    if (selected_notification)
      this.props.editNotification(
        selected_notification.id,
        info,
        this.auth_token,
        "notification-lists"
      );
    this.modelClose();
  };

  /**
 * Closes the currently open modal by updating state.
 */
  modelClose = () => {
    this.setState({ open_modal: false });
  };

  /**
   * getModalContent
   *
   * @returns {JSX.Element} - The content of the modal based on the notification mode.
   */
  getModalContent = () => {
    let content: JSX.Element = <></>;
    const { notification_mode, selected_notification } = this.state;
    switch (notification_mode) {
      case NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.EDIT:
        content = (
          <NotificationCreator teams_context={this.state.teams_context}
            is_create_notification={false}
            saveNotification={this.updateNotification}
            notification={selected_notification}
          />
        );
        break;

      case NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.DELETE:
        content = (
          <div id="delete-message">
            {NOTIFICATIONCONFIG.NOTIFICATIONLIST.DELETEMESSAGE}
          </div>
        );
        break;

      case NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.VIEWCARD:{
        const {
          template_config,
          table_data,
          teams_filter
        } = this.props.card_html;
        content = template_config ?
          <TeamsCard
            is_update_chart_view_state={this.props.is_update_chart_view_state}
            display_card_name={true}
            template_config={template_config}
            table_data={table_data}
            teams_filter={teams_filter}
          ></TeamsCard> : <></>
        break;
      }
      default:
        break;
    }
    return content;
  };

  /**
   * getModalSize
   *
   * @returns {string} - The size of the modal based on the notification mode.
   */
  getModalSize = () => {
    let { notification_mode } = this.state;
    switch (notification_mode) {
      case NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.DELETE:
        return 'mini';
      case NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.VIEWCARD:
        return 'large';
      default:
        return 'small';
    }
  };

  /**
   * isPopUpEnabled
   *
   * @param {any} event - The event object.
   * @param {number} notification_id - The ID of the notification.
   * Sets the state to open the popup if the element's width is less than its scroll width.
   */
  isPopUpEnabled = (event: any, notification_id: number) => {
    let target_elem = event.target;
    if (target_elem.getBoundingClientRect().width < target_elem.scrollWidth) {
      this.setState({ open_notification_name_popup: notification_id });
    }
  };

  /**
   * disablePopup
   *
   * Disables the popup by setting the state to -1.
   */
  disablePopup = () => {
    if (this.state.open_notification_name_popup !== -1) {
      this.setState({ open_notification_name_popup: -1 });
    }
  };

  /**
   * getNotificationScope
   *
   * @param {string} conversation_type - The type of conversation (personal, channel, or group).
   * @returns {string} - The scope of the notification based on the conversation type.
   */
  getNotificationScope = (conversation_type: string) => {
    switch (conversation_type) {
      case NOTIFICATIONCONFIG.NOTIFICATIONCONVERSATIONTYPE.PERSONAL:
        return NOTIFICATIONCONFIG.NOTIFICATIONSCOPE.PERSONAL;

      case NOTIFICATIONCONFIG.NOTIFICATIONCONVERSATIONTYPE.CHANNEL:
        return NOTIFICATIONCONFIG.NOTIFICATIONSCOPE.CHANNEL;

      default:
        return NOTIFICATIONCONFIG.NOTIFICATIONSCOPE.GROUP;
    }
  }

  /**
   * renderNoNotificationMessage
   *
   * @returns {JSX.Element} - A message indicating that no notifications are available.
   */
  renderNoNotificationMessage = () => {
    return !this.props.active_loader ? <Segment placeholder textAlign="center" size="large">
      {NOTIFICATIONCONFIG.NOTIFICATIONNOTAVAILABLE}
    </Segment> : <></>;
  }

  /**
   * clearErrorMessage
   *
   * Clears the error message if it is not empty.
   */
  clearErrorMessage = () => {
    if (this.props.notification_msg !== '') {
      this.props.setNotificationMessage('');
    }
  }

  /**
   * render
   *
   * Renders the NotificationList component.
   * Displays a table of notifications, a modal for editing/deleting/viewing notifications,
   * and handles various UI states (loading, error messages, etc.).
   */
  render() {
    let { active_loader, notifications, notification_msg, is_license_expire, is_unregisterd_user, unregisterd_user_msg } = this.props;
    let { notification_mode, teams_context } = this.state;
    let headers = Object.values(
      NOTIFICATIONCONFIG.NOTIFICATIONLIST.TABLEHEADER
    );
    console.log("teams_context :: ", teams_context,is_unregisterd_user,is_license_expire);
    if (is_unregisterd_user) {
      return <Segment dangerouslySetInnerHTML={{ __html: unregisterd_user_msg }}
        placeholder textAlign="center" size="large" />
    }
    else if (is_license_expire) {
      return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
    } else if (!active_loader && teams_context.userObjectId) {
      return (
        <>
          {notifications.length > 0 ? (
            <Table id="notification-table" basic="very" unstackable>
              <Table.Header>
                <Table.Row>
                  {headers.map((header, i) => {
                    return (
                      <Table.HeaderCell
                        key={`headercell${header}`}
                        content={header}
                        textAlign={i === headers.length - 1 ? 'center' : 'left'}
                      />
                    );
                  })}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {notifications.map((notification, i) => {
                  let is_incosistent_roles = notification.details && notification.details.trim() !== '';
                  let clsname = is_incosistent_roles ? 'red-color' : '';
                  let status = notification.active
                    ? NOTIFICATIONCONFIG.NOTIFICATIONLIST.STATUS.DISABLE
                    : NOTIFICATIONCONFIG.NOTIFICATIONLIST.STATUS.ENABLE;
                  return (
                    <Table.Row key={`row${notification.name}`}>
                      <Table.Cell
                        textAlign="left"
                        className={`sequence-no ${clsname}`}
                        content={`${i + 1}.`}
                      />
                      <Table.Cell
                        textAlign="left"
                        className={`notification-name ${clsname}`}
                        content={<>
                          <Popup
                            trigger={
                              <Label
                                onMouseOver={(e: any) =>
                                  this.isPopUpEnabled(e, notification.id)
                                }
                                onMouseLeave={(e: any) => this.disablePopup()}
                                className={'add-ellipsis-to-text'} basic
                                content={notification.name} />
                            }
                            position="bottom center"
                            on="hover"
                            hoverable
                            basic
                            content={notification.name}
                            open={
                              this.state.open_notification_name_popup ===
                              notification.id
                            }
                          />
                          {is_incosistent_roles ? <Popup position='bottom center'
                            content={notification.details} className='info'
                            trigger={<Icon color='red' name='info circle' />} /> : null}
                        </>
                        }
                      />
                      <Table.Cell
                        textAlign="left"
                        className={`created-by ${clsname}`}
                        content={is_incosistent_roles ? null :
                          <Label
                            basic
                            content={notification.created_by}
                          />
                        }
                      />
                      <Table.Cell
                        textAlign="left"
                        className={`scope ${clsname}`}
                        content={is_incosistent_roles ? null :
                          <Label
                            basic
                            content={this.getNotificationScope(
                              notification.data.conversation_type
                            )}
                          />
                        }
                      />
                      
                      <Table.Cell
                        textAlign="left"
                        className={`created-on ${clsname}`}
                        content={is_incosistent_roles ? null : notification.created_on}
                      />
                      <Table.Cell
                        textAlign="left"
                        className={`last-delivered ${clsname}`}
                        content={is_incosistent_roles ? null : notification.last_delivered}
                      />
                      <Table.Cell
                        textAlign="center"
                        className="action-buttons"
                        content={
                          <span className="btn-group">
                            {is_incosistent_roles ? null : <button
                              className="btn btn-sm edit-btn"
                              onClick={() => this.editNotification(notification)}
                            >
                              {NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.EDIT}
                            </button>}
                            {is_incosistent_roles ? null : <button
                              className="btn btn-sm status-btn"
                              onClick={() => this.updateNotificationStatus(notification)}
                            >
                              {status}
                            </button>}
                            <button
                              className="btn btn-sm delete-btn"
                              onClick={() =>
                                this.openDeleteConfirmationDialog(notification)
                              }
                            >
                              {NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.DELETE}
                            </button>
                            {is_incosistent_roles ? null : <button
                              className="btn btn-sm view-card-btn"
                              onClick={() =>
                                this.viewNotificationCard(notification)
                              }
                            >
                              {
                                NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION
                                  .VIEWCARD
                              }
                            </button>}
                          </span>
                        }
                      />
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          ) : this.renderNoNotificationMessage()
          }

          {notification_msg.trim() !== '' && !this.state.open_modal ? (
            <div id="notification-message-container">
              <Message
                error
                content={notification_msg}
                onDismiss={() => this.props.setNotificationMessage('')}
              />
            </div>
          ) : null}

          <Modal
            closeOnDimmerClick={false}
            closeOnEscape={true}
            open={this.state.open_modal}
            onClose={this.modelClose}
            id="notification-modal"
            size={this.getModalSize()}
            onMount={() => this.clearErrorMessage()}
            onUnmount={() => this.clearErrorMessage()}
          >
            <Modal.Header>
              <Menu>
                <Header as="h4" content={notification_mode} />
                <Menu.Menu position="right">
                  <Button
                    circular
                    basic
                    icon="close"
                    size="large"
                    id="modal-close-btn"
                    onClick={this.modelClose}
                  />
                </Menu.Menu>
              </Menu>
            </Modal.Header>
            <Modal.Content className="notification-modal-content">
              {notification_msg.trim() !== '' ? (
                <Message attached='top'
                  error
                  content={notification_msg}
                  onDismiss={() => this.props.setNotificationMessage('')}
                />
              ) : null}
              {this.getModalContent()}
            </Modal.Content>
            {notification_mode ===
              NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.DELETE ? (
              <Modal.Actions>
                <Button
                  basic
                  onClick={() => {
                    this.modelClose();
                  }}
                >
                  {NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.CANCEL}
                </Button>
                <Button color="teal" onClick={() => this.deleteNotification()}>
                  {NOTIFICATIONCONFIG.NOTIFICATIONLIST.ACTION.OK}
                </Button>
              </Modal.Actions>
            ) : null}
          </Modal>
        </>
      );
    } else {
      return <></>
    }
  }
}

/**
 * Maps the relevant portions of the application state to props for the NotificationList component.
 * 
 * Retrieves notification data, user session details, and various UI state indicators from the Redux store state.
 *
 * @param {Object} state - The current Redux state of the application.
 * @returns {Object} A props object containing:
 * - notifications: A deep copied list of notifications.
 * - card_html: A deep copied HTML string of the notification card.
 * - notification_msg: The current notification message.
 * - theme: The current UI theme.
 * - is_license_expire: A boolean indicating if the license has expired.
 * - is_unregisterd_user: A boolean indicating if the user is unregistered.
 * - unregisterd_user_msg: The message for unregistered users.
 * - active_loader: A boolean indicating if a loader is active.
 * - is_update_chart_view_state: A boolean indicating if the chart view state is updated.
 * - sessionId: The current session ID.
 */

const mapStateToProps = (state: any) => {
  let { notifications, card_html, notification_msg } = state.notificationState;
  let {sessionId} = state.viewState;
  return {
    notifications: JSON.parse(JSON.stringify(notifications)),
    card_html: JSON.parse(JSON.stringify(card_html)),
    notification_msg: notification_msg,
    theme: state.viewState.theme,
    is_license_expire: state.viewState.is_license_expire,
    is_unregisterd_user: state.viewState.is_unregisterd_user,
    unregisterd_user_msg: state.viewState.unregisterd_user_msg,
    active_loader: state.viewState.active_loader,
    is_update_chart_view_state: state.cardLibraryState.is_update_chart_view_state,
    sessionId
  };
};

export default connect(mapStateToProps, {
  getNotifications,
  getCardHTML,
  editNotification,
  deleteNotification,
  setNotificationMessage,
  activeLoader,
  storeSessionId
})(NotificationList);
